  
  import { axiosPost } from './http';

  const prexfix = global.$config.api.analysisUrl;
  // const prexfix = 'https://biaozhunhua.zjht100.com/tsscjk'
  // const prexfix = 'http://biaozhunhua.zjht100.com'
  
  // 巡检首页
  export const findLatestPage = (data) => {
    const params = {
      baseUrl: prexfix,
      data: data
    }
    return axiosPost(`/bizUserPosition/findLatestPage`, params)
  };
  //首页 今日二销
  export const getAreaYOYMOMData = (data) => {
    const params = {
      baseUrl: prexfix,
      data: data
    }
    return axiosPost(`/staTicketSell/getAreaYOYMOMData`, params)
  };
    //首页 今日二销
  export const getAreaYOYMOMDataPassenger = (data) => {
      const params = {
        baseUrl: prexfix,
        data: data
      }
      return axiosPost(`/staPassengerAnalysis/getAreaYOYMOMData`, params)
    };

  //首页 通讯
  export const resAppLocation = (data) => {
    const params = {
      baseUrl: prexfix,
      data: data
    }
    return axiosPost(`/resAppLocation/realtime`, params)
  };